<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3" id="ch02"><a id="page_9"></a><span class="small">TWO</span></h3>
<p class="noindenta">Is the hip broken? The leg? Which? She understands that the pain is so great, her body is not large enough to hold it. It leaps from her forehead, her nose, her joints, her mouth; it oozes from a gash in the side of her neck; it wraps up her heels and ribs; it thrusts a javelin into her cheekbone and heaves a sword, which splits her thigh. It hovers above the lids of her eyes and sinks deep into her orbits. She stares straight up and is surprised to see the forked branch of a tree, a padding of cloud that tucks up the edges of sky. On the ground, lumps of darkness threaten and spread around her. Words cartwheel across her mind and she squints, hard, in an effort to slow them down: <em>wheel pillow palace tree wheel pillow palace tree</em>. No other sound is contained in memory, no matter how much she pries.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?3b1fab64